enum TiposUso {
    Sistemico = 1,
    Topico = 2,
    Oftalmico = 3,
    Injetavel = 4,
    Subcutaneo = 5,
}

export default TiposUso;
